// Search slice – manages search query state
import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "search",
  initialState: {
    query: "",
  },
  reducers: {
    setQuery: (state, { payload }) => {
      state.query = payload;
    },
  },
});

export const { setQuery } = searchSlice.actions;

export const selectQuery = (state) => state.search.query;

export default searchSlice.reducer;
